import { useState } from "react";
import { m } from "#/paraglide/messages";
import { reportError } from "../report-error";

type DefaultErrorProps = {
	message?: string;
	error?: unknown;
	onRetry?: () => unknown;
};
export default function DefaultError({
	message,
	error,
	onRetry,
}: DefaultErrorProps) {
	// Reporting is idempotent per error. A failed retry can supply a new error
	// without unmounting this view, and must display the new reference.
	const referenceId = error
		? reportError(error, { operation: "render" })
		: undefined;
	const [pending, setPending] = useState(false);
	const retry = async () => {
		if (pending) return;
		if (!onRetry) {
			window.location.reload();
			return;
		}
		setPending(true);
		try {
			await onRetry();
		} catch (failure) {
			reportError(failure, { operation: "retry" });
		} finally {
			setPending(false);
		}
	};
	return (
		<div className="read-width mx-auto py-12">
			<div role="alert">
				<h1 className="h1">{m.page_error_heading()}</h1>
				<p className="mb-3">{m.page_error_description()}</p>
				{referenceId ? (
					<p className="mb-3">{m.page_error_reference({ referenceId })}</p>
				) : null}
				{import.meta.env.DEV && message ? (
					<p>
						<b>{m.page_error_message()}</b>
						<br />
						{message}
					</p>
				) : null}
				<div className="flex flex-wrap gap-3">
					<button
						type="button"
						className="btn btn-primary"
						disabled={pending}
						onClick={retry}
					>
						{m.page_error_try_again()}
					</button>
					<a className="btn btn-outline-primary" href="/">
						{m.page_error_home()}
					</a>
				</div>
			</div>
		</div>
	);
}
